import React, { useEffect, useState } from 'react';
import { api } from '../api/client';

const pageStyles = ".blink {\n        animation: blink_animation 1s infinite;\n    }\n\n    @keyframes blink_animation {\n        0% {\n            opacity: 1;\n        }\n        50% {\n            opacity: 0;\n        }\n        100% {\n            opacity: 1;\n        }\n    }";

export default function InfoPage() {
  const [site, setSite] = useState({
    name: 'Revival Pharmacy',
    phone: '(306) 559-3228',
    alternatePhone: '',
    email: 'bhavya@revivalpharmacy.ca',
    address: '1168 Albert Street, Regina, SK, S4R 2R1, Canada',
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    api.publicSettings().then(setSite).catch(() => {});
  }, []);
  return (
    <>
      <style>{pageStyles}</style>
      <section className="doc_community">
          <div className="container">
              <div className="row">
                  <div className="col-lg-12">
                      <div className="doc_community_text">
                          <h1>Find Your Way to <a className="text-white" href="https://maps.app.goo.gl/piQiW5AXBaCA6rQu8"><b className="blink">{site.name}</b></a> in Regina, Canada</h1>
                          <p>Explore the convenient location of Revival Pharmacy, situated in the heart of Regina, Canada, committed to providing exceptional pharmaceutical care and support tailored to your needs.</p>
                      </div>

                  </div>
              </div>
          </div>
      </section>

      <section className="map-section">
          <div className="container">
              {/*Map Outer*/}
              <div className="row justify-content-center">
                  <div className="col-lg-8 col-md-10">
                      {/*Map Section*/}
                      <div className="embed-responsive embed-responsive-16by9">
                          <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d10159.907093700662!2d-104.6183373!3d50.4601572!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x531c1f7473f9e205%3A0x4d128b1d29f2a376!2sREVIVAL%20PHARMACY!5e0!3m2!1sen!2sin!4v1712379169822!5m2!1sen!2sin" className="embed-responsive-item" allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                      </div>
                  </div>
              </div>
          </div>
      </section>

      <div className="contact_through">
          <div className="container">
              <div className="row">
                  <div className="col-lg-3 col-md-3 col-sm-6">
                      <div className="contact_through_inner">
                          <span className="fa fa-phone icon"></span>
                          <p>
                              Contact : <br />
                              {site.phone}
                              {site.alternatePhone && <><br />{site.alternatePhone}</>}
                          </p>
                      </div>
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-6">
                      <div className="contact_through_inner">
                          <span className="fa fa-map-marker icon"></span>
                          <p>
                              {site.address}
                          </p>
                      </div>
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-6">
                      <div className="contact_through_inner">
                          <span className="fa fa-envelope icon"></span>
                          <p>
                              Email<br />
                              {site.email}
                          </p>
                      </div>
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-6">
                      <div className="contact_through_inner">
                          <span className="fa fa-fax icon"></span>
                          <p>
                              Fax Number<br />
                              (306) 205-2381
                          </p>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </>
  );
}
